<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">Calibration Certificate Delivery Form </h5>
     <br/>
     <br/>
     <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description  </label>
        <input  type="text" class="form-control"  [(ngModel)]="Dsc_Form"  placeholder=" Type here...">
      </div>
    </div>
      <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing && EditRecord==0"  type="button" (click)="openModal_Certificate(templateCertificate)"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus"></i> Add Calibration Certificate </button>
        <button *ngIf="!Procssing && EditRecord==0" type="button" (click)="OnSubmitForm()" [disabled]="DataList_Calibration.length==0" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus"></i> Confirm and Finalize </button>
        <button routerLink="/CertifivateDelivery" *ngIf="!Procssing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>
     <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Calibration Certificate Code</th>
            <th>Receipt Number</th>
            <th>Instrument Name</th>
            <th>Instrument Code</th>
            <th>Instrument Serial Number</th>
            <th *ngIf="EditRecord==0">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of DataList_Calibration">
            <td>{{DataList_Calibration.indexOf(item)+1}}</td>
            <td>{{item.expiration_title}}</td>
            <td>{{item.dsc}}</td>
            <td>{{item.device_name}}</td>
            <td>{{item.device_code}} </td>
            <td>{{item.device_serial}} </td>
            <td  *ngIf="EditRecord==0" style="cursor: pointer;">
              <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;" (click)="DataList_Calibration_Remove(DataList_Calibration.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> Delete </a>
                    </div>
                </div>
              </div>

            </td>

          </tr>
        </tbody>
      </table>
  </div>
    </div>

  </div>
</div>


<ng-template #templateCertificate>
  <div class="modal-header">
     <h4 class="modal-title pull-left">Calibration Certificate List  </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Certificate.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
            <label for="exampleInputEmail1">Calibration Certificate Code  </label>
            <input  type="text" class="form-control" (keyup)="ReadData_Certificate_KeySearch()"  [(ngModel)]="Search_Code_Certificate_Table"  placeholder="Type here to search...">
        </div>
      </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Calibration Certificate Code</th>
              <th>Receipt Number</th>
              <th>Instrument Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Data_Certificate_Search">
                      <td>{{Data_Certificate_Search.indexOf(item)+1}}</td>
                      <td>{{item.expiration_title}}</td>
                      <td>{{item.dsc}}</td>
                      <td>{{item.device_name}}</td>
                      <td (click)="Set_Selected_Certificate_Record(item)" style="cursor: pointer;">
                        <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
                      </td>

            </tr>
          </tbody>
        </table>
    </div>
  </div>
 </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_Certificate" src="assets/Loading.gif" style="width: 25px;" />
    <button  *ngIf="!Procssing_Certificate" type="button" (click)="ReadData_Certificate()"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Certificate.hide()">Close</button>
  </div>
</ng-template>
